(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var st;
    var lastScrollTop = 0;
    var headerHeight = 0;
    var interval
    var interval2
    var interval3
    var interval4
    var isMobile = false;

    let $grid;
    let filters;
    let collections_obj;
    let lighting_cats;
    let furniture_cats;

    if ($win.width() < 767) {
        isMobile = true;
    }
    var isTablet = false;
    if ($win.width() < 1024) {
        isTablet = true;
    }

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    function initSliders() {
        $('.js-slider').flickity({
            groupCells: true,
            wrapAround: true,
            groupCells: 2,
            draggable: true,
            contain: true,

        });

        $('.js-slider--alt').flickity({
            groupCells: true,
            wrapAround: true,
            groupCells: 1,
            draggable: true,
            contain: true,
        });

        $('.js-slider-products').flickity({

            draggable: true,
            contain: true,
            freeScroll: false,
            wrapAround: true,
            groupCells: true,
            groupCells: '33.33%'
        });

        $('.js-slider-products--alt').flickity({

            draggable: true,
            contain: true,
            freeScroll: false,
            wrapAround: false,
            groupCells: true,
            groupCells: '33.33%'
        });

    }

    function sliderTablet() {
        if (!$('.slider').length) {
            return
        }
        $('.slider').each(function () {
            if (isTablet == true) {
                $(this).removeClass('slider--fade')
            }
        })
    }

    function clickHandlers() {
        $('.js-toggle').on('click', function (e) {
            e.preventDefault();
            $('.header').toggleClass('is-open');
            $(this).toggleClass('is-active');
            $('.has-dropdown').removeClass('expanded');
        })

        $('.js-search').on('click', function (e) {
            e.preventDefault();
            $('.search').toggleClass('visible');
        })

        //Dropdown Navigation
        $('.nav li a').on('click', function (e) {
            if ($win.width() > 1023) {
                return;
            }

            const parent = $(this).parent();

            if (parent.hasClass('has-dropdown') & parent.hasClass('expanded')) {
                parent.removeClass('expanded')
                e.preventDefault();
                return;
            }

            if (parent.hasClass('has-dropdown') & !parent.hasClass('expanded')) {
                parent.addClass('expanded').siblings().removeClass('expanded');
                e.preventDefault();
            }
        });

        $(".load-more").click(function (e) {
            e.preventDefault();

            var $this = $(this)
            var $container = $('.articles-blog')
            var url = $this.attr('href')
            var filterValue = $('.nav-filter .is-active a').data('filter') || '*'

            $.ajax({
                method: 'GET',
                type: 'HTML',
                url: url,
                async: false,

                success: function (response) {
                    var $response = $(response);

                    $container.append($response)

                    var $nextLink = $container.find('.more-items')

                    if ($nextLink.length) {
                        $this.attr('href', $nextLink.attr('href'))

                        $nextLink.remove()
                    } else {
                        $container
                            .closest('.section-blog')
                            .addClass('hide-actions')
                    }


                    setTimeout(function () {
                        $container
                            .isotope('appended', $response)

                        $container.isotope({ filter: filterValue });
                    }, 50);
                }
            });
        });

        $('.js-toggle-color').on('change', 'input', function (e) {
            e.preventDefault();

            let $this = $(this);
            let value = $this.val()
            let items = $this.parents('.section-shop').find('.item')
            let overlay = $this.parents('.section-shop').find('.item__overlay')
            let parentListItem = $this.parents('li').eq(0);
            let siblings = $(parentListItem).siblings('li');

            if ($this.is(':checked')) {
                $(siblings).each(function () {
                    $(this).find('input[type="checkbox"]')
                        .attr('checked', false)
                        .prop('checked', false)
                });

                $(items).find('.img-default').addClass('is-active');
                $(items).find('.' + value).addClass('current')
                    .siblings()
                    .removeClass('current')

                $(overlay).addClass("item__overlay--active")
                $(items).find('a').removeClass()
                $(items).find('a').addClass(value + '-hover')
            } else {
                $(items).find('.img-default').removeClass('is-active');
                $(items).find('.' + value).remove('current')
                    .siblings()
                    .removeClass('current')

                $(overlay).removeClass("item__overlay--active")
                $(items).find('a').removeClass()
                $(items).find('a').removeClass(value + '-hover')
            }

        })



        $('.footer a').on('click', function (e) {
            let href = $(this).attr('href');
            let subscribe = $('.subscribe:not(.subscribe--alt)');
            if (href == '#subscribe') {
                e.preventDefault();
                subscribe.addClass('visible')
            }
        })



        $('.js-close-subscribe').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.subscribe').removeClass('visible')
        })

        $(".search input").on('keyup', function () {
            var val = $(this).val()

            if (val.length > 0 && !$('.search').hasClass('items')) {
                $(this).parents('.search').addClass('items')
                return;
            } else if (val.length == 0 && $('.search').hasClass('items')) {
                $(this).parents('.search').removeClass('items')
            }

        });
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    function filter_by_colour_url() {
        switch (getUrlParameter('color')) {
            case 'warm':
                $(this).addClass('item__overlay--active')
                $(this).find('.img-warm').addClass('current')
                $('.radio input[id="warm"]').trigger('click');
                break;

            case 'light':
                $(this).addClass('item__overlay--active')
                $(this).find('.img-light').addClass('current')
                $('.radio input[id="light"]').trigger('click');
                break;

            case 'cool':
                $(this).addClass('item__overlay--active')
                $(this).find('.img-cool').addClass('current')
                $('.radio input[id="cool"]').trigger('click');
                break;

            case 'dark':
                $(this).addClass('item__overlay--active')
                $(this).find('.img-dark').addClass('current')
                $('.radio input[id="dark"]').trigger('click');
                break;
        }
    }

    function initCounter() {
        var targetDate = $('.js-counter .counter__clock').data('target-date')
        $('.js-counter .counter__clock').countdown(targetDate, function (event) {
            $(this).html(event.strftime('%D . %H . %M <span>%S</span>'));
        });
    }

    function initShortCounter() {
        var targetDate = $('.js-short-counter .counter__clock').data('target-date')
        $('.js-short-counter .counter__clock').countdown(targetDate, function (event) {
            $(this).html(event.strftime('%D . %H . %M <span>%S</span>'));
        });
    }

    $('.accordion .accordion__body').slideUp(0);
    // $('.accordion .accordion__section:first-child .accordion__body').slideDown(0);
    // $('.accordion .accordion__section:first-child').addClass('is-current')

    $('.accordion--filter .accordion__section:first-child .accordion__body').slideUp(0);
    $('.accordion--filter .accordion__section:first-child').removeClass('is-current');
    $('.accordion__checkout .accordion__section').removeClass('is-current')
    $('.accordion__checkout .accordion__body').slideUp(0);

    function runAccordion() {
        $('.js-accordion .accordion__head').on('click tap', function (e) {
            let currentAcc = $(this).parent();
            let accBody = currentAcc.find('.accordion__body');

            if (currentAcc.hasClass('is-current')) {
                accBody.slideUp('slow');
                currentAcc.removeClass('is-current');
                return;
            }

            accBody.slideDown();
            currentAcc.addClass('is-current');
        });

        let behaviour = $('.accordion').data('behaviour');
        $('.js-accordion-alt .accordion__head').on('click tap', function (e) {
            let currentAcc = $(this).parent();
            let accBody = currentAcc.find('.accordion__body');
            let accSiblings = currentAcc.siblings()

            if (currentAcc.hasClass('is-current')) {
                accBody.slideUp('slow');
                currentAcc.removeClass('is-current');
                return;
            }

            accBody.slideDown();
            currentAcc.addClass('is-current');

            if (behaviour != 'multiple') {
                accSiblings
                    .removeClass('is-current')
                    .find('.accordion__body')
                    .slideUp();
            }

        });
    }

    function runMobileAccordion() {
        if ($win.width() > 768) {
            return
        }

        $('.js-accordion-mobile ul').slideUp(0);
        $('.js-accordion-mobile h4').on('click tap', function (e) {
            let currentAcc = $(this).parent();
            let accBody = currentAcc.find('ul');

            if (currentAcc.hasClass('is-current')) {
                accBody.slideUp('slow');
                currentAcc.removeClass('is-current');
                return;
            }

            accBody.slideDown();
            currentAcc.addClass('is-current');
        });
    }
    // function tonalCircles() {
    //     var circles = $(".circles-tonal ul li a");
    //     $(circles).each((function(i, el) {
    //         var horizontal = Math.floor(10 * Math.random() + 1), 
    //             vertical = Math.floor(10 * Math.random() + 1), 
    //             scale = Math.floor(10 * Math.random() + 1) / 10;

    //         var width = $(this).width() * (0.4 + scale),
    //             height = $(this).height() * (0.4 + scale);

    //             if(width < 300){
    //                 width = 500
    //                 height = 500
    //             }
    //             if(width > 500){
    //                 width = 400
    //                 height = 400
    //             }
    //             console.log(0.6 + scale);
    //             (0.8 + scale) > .8 && (0.6 + scale) < 1.2  ? $(el).css({
    //             transform: `translate(${horizontal}%,${vertical}%)`,
    //             width: width,
    //             height: height,
    //         }) : $(el).css({
    //             transform: ` translate(-${horizontal}%,-${vertical}%)`
    //         });
    //         //     scale < .6 && (scale += .6), i % 2 != 0 ? $(el).css({
    //         //     transform: `scale(${scale}) translate(${horizontal}%,${vertical}%)`
    //         // }) : $(el).css({
    //         //     transform: `scale(${scale}) translate(-${horizontal}%,-${vertical}%)`
    //         // });
    //     }));
    // }

    function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + .1) + min) / 100
    }

    function tonalCircles() {
        var circles = $(".circles-tonal ul li a");
        $(circles).each((function (i, el) {
            var horizontal = Math.floor(30 * Math.random() + 1),
                vertical = Math.floor(30 * Math.random() + 1),
                scale = randomIntFromInterval(1, 30) + 1
            var label = $(this).find('span')


            if ($(window).width() < 767) {
                scale -= 0.7;
                horizontal -= 15;
            }

            if (i == 1) {

                $(el).css({
                    'transform': `scale(${scale}) translate(${horizontal}%,${vertical}%)`
                })

                $(el).find('span').css({
                    'fontSize': 20,
                    'scale': 1
                })
                // label.css({
                //     transform: `scale(${scaleFactor}) `,
                //     fontSize : '2rem!important',
                //     } )
                label.width(100)
                label.height(100)

            }
        }))
    }

    function tonalCircles2() {
        var circles = $(".circles-tonal ul li a");
        $(circles).each((function (i, el) {
            var horizontal = Math.floor(30 * Math.random() + 1),
                vertical = Math.floor(30 * Math.random() + 1),
                // scale       = Math.floor(10 * Math.random() + 1) / 10;
                scale = randomIntFromInterval(1, 30) + 1

            if (i == 0) {
                scale = randomIntFromInterval(1, 45) + 1
                var label = $(this).find('span')

                if ($(window).width() < 767) {
                    scale -= 0.8;
                    horizontal -= 15;
                }


                $(el).css({
                    transform: `scale(${scale}) translate(${horizontal}%,${vertical}%)`
                })
                label.width(100)
                label.height(10)

            }
        }))
    }

    function tonalCircles3() {
        var circles = $(".circles-tonal ul li a");
        $(circles).each((function (i, el) {
            var horizontal = Math.floor(30 * Math.random() + 1),
                vertical = Math.floor(30 * Math.random() + 1),
                scale = randomIntFromInterval(1, 30) + 1

            if ($(window).width() < 767) {
                scale -= 0.7;
                horizontal -= 15;
            }

            // scale < .65 && (scale += .65)
            var scaleFactor = 1 / scale
            if (i == 2) {
                var label = $(this).find('span')

                $(el).css({
                    transform: `scale(${scale}) translate(${horizontal}%,${vertical}%)`
                })
                label.width(100)
                label.height(10)

            }
        }))
    }

    function tonalCircles4() {
        var circles = $(".circles-tonal ul li a");
        $(circles).each((function (i, el) {
            var horizontal = Math.floor(30 * Math.random() + 1),
                vertical = Math.floor(30 * Math.random() + 1),
                // scale       = Math.floor(10 * Math.random() + 1) / 10;
                scale = randomIntFromInterval(1, 30) + 1

            if ($(window).width() < 767) {
                scale -= 0.7;
                horizontal -= 15;

            }

            if (i == 3) {
                var label = $(this).find('span')

                $(el).css({
                    transform: `scale(${scale}) translate(${horizontal}%,${vertical}%)`
                })
                label.width(100)
                label.height(10)

            }
        }))
    }

    function tonalCirclesEvents() {
        var circles = $('.circles-tonal ul li a')

        $('.circles-tonal a').on('mouseenter', function (e) {
            e.stopPropagation()
            clearInterval(interval)
            clearInterval(interval2)
            clearInterval(interval3)
            clearInterval(interval4)

            var target = e.target;

            $(circles).each(function (i, el) {
                var transform = $(this).css('transform');
                var label = $(target).find('span')

                let _scale = 1.3;
                let _labelScale = 1;

                if ($(window).width() < 767) {
                    _scale = 0.5;
                    _labelScale = 0;
                }

                label.css({
                    fontSize: '1rem',
                    transform: `scale(${_labelScale})`,
                })
                label.width(100)
                label.height(10)
                $(this).css({
                    transform: transform,
                });
                $(target).css({
                    transform: `scale(${_scale})`,
                });
            })

        })

        $('.circles-tonal a').on('mouseleave', function (e) {
            e.stopPropagation()
            tonalCircles()
            tonalCircles2()
            tonalCircles3()
            tonalCircles4()
            circlesTonalIntervals()
        })
    }

    function circlesTonalIntervals() {
        interval = setInterval(function () {
            tonalCircles()
        }, 3000);
        interval2 = setInterval(function () {
            tonalCircles2()
        }, 4100);
        interval3 = setInterval(function () {
            tonalCircles3()
        }, 4000);
        interval4 = setInterval(function () {
            tonalCircles4()
        }, 3550);

    }

    function scrollHandlers(st, lastScrollTop) {
        if (st > lastScrollTop && st > 150) {
            $('.header').addClass('hide background')

            $('.js-sticky').css('top', 0);
            return
        } else if (st < lastScrollTop) {
            $('.header').removeClass('hide')

            $('.js-sticky').css('top', headerHeight - 3);
        }
        if (st > 10) {
            $('.header').addClass('background')
            $('.js-sticky').css('top', headerHeight - 3);
        }
        if (st < 150 && st < lastScrollTop) {
            $('.header').removeClass('hide background')
        }
    }

    function initAos() {
        const $container = $(".slider, .hero, .section, .section-simple, .article, .member, .widget-counter, .section-products, .intro, .section-tiles, .section-details, .section-review, .project, .section-shop, .form, .section-alt, .section-accordion, .section--intro, .slider--hero");
        const $itemsUp = $(".slider .slider__content, .hero .hero__content, .section h2, .section .section__slider, .section .section__entry,.section .section__counter, .section .section__images, .section .section__content, .section .section__col, .section-simple img, .section-simple .section__content, .article .article__body, .article .article__image, .member img, .member .member__content, .section .section__cta, .widget-counter .counter, .intro h2, .intro img, .intro .intro__content, .section-details .section__title, .section-details .section__list, .section-review .section__inner, .project .project__image, .project .project__content, .form .form__inner, .section-alt .section__content, .section-accordion .accordion, .section--intro img, .section--intro h2, .section--intro .section__content, .slider--hero .slider__content");
        const $itemsGroup = $('.section .section__list ul li, .section-products .product, .section-tiles .tile, .section--intro .section__entry--journal')

        $container.each(function () {
            const $container = $(this);
            const $containerItems = $container.find($itemsUp);
            const $containerItems2 = $container.find($itemsGroup);
            // let delay = 300;
            let delay = 0;

            $containerItems.each(function () {
                delay = $(this).attr('data-aos-delay') ? $(this).attr('data-aos-delay') : 250;

                $(this).attr({
                    "data-aos-delay": delay,
                    "data-aos": "fade-up-subtle",
                    "data-aos-easing": "ease-in-out",
                });

                delay += 80;
            });

            $containerItems2.each(function () {
                delay = $(this).attr('data-aos-delay') ? $(this).attr('data-aos-delay') : 200;

                $(this).attr({
                    "data-aos-delay": delay,
                    "data-aos": "fade-up-subtle",
                    "data-aos-easing": "ease-out",
                });

                delay += 100;
            });

            $win.on("scroll resize", function () {
                if ($container.hasClass("aos-animate")) {
                    $containerItems.addClass("aos-animate");
                }
            });

            setTimeout(function () {
                if ($container.hasClass("aos-animate")) {
                    $containerItems.addClass("aos-animate");
                }
            }, delay);
        });


        AOS.init({
            duration: 800,
            once: true,
        });

    }

    function concatValues(obj, $separator) {
        var value = '';
        for (var prop in obj) {

            value += ($separator + obj[prop]);
        }
        return value;
    }
    // Helper: Count Properties on an object
    function countProperties(obj) {
        var count = 0;

        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                ++count;
        }

        return count;
    }
    // Helper: remove specific item on array
    function removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }
        return arr;
    }

    function getKeyByValue(object, value) {
        return Object.keys(object).find(key => object[key] === value);
    }

    const addPrefix = (string, prefix) => {
        const pref = prefix;
        const newText = prefix.concat(string);

        return newText;
    };

    /*
    *  Shop Filters
    */
    function initIsotope() {
        // console.log("Initalized Isotope!");
        $('.section-shop .grid .grid__col').equalizeHeight()
        $grid = $('.js-grid').isotope({
            itemSelector: '.grid__col'
        });

        filters = {};

        collections_obj = {
            "lighting": {
                "ceto": ['wall-light', 'pendant', 'cluster', 'chandelier', 'floor-lamp'],
                "nebulae": ['wall-light', 'pendant', 'chandelier'],
                "ora": ['pendant', 'desk-lamp'],
                "polar": ['wall-light', 'desk-lamp'],
                "silhouette": ['wall-light', 'pendant', 'desk-lamp'],
                "oak": ['pendant'],
                "arbour": ['pendant'],
                "hemera": ['desk-lamp']
            },
            "furniture": {
                "duet": ['stool'],
                "half-full": ['stool'],
                "tailored": ['lounge'],
                "noon": ['lounge', 'mirror', 'rug', 'accesories', 'coffee-table'],
                "adapt": ['lounge', 'ottoman'],
                "adapt-soft": ['lounge'],
                "place": ['lounge'],
                "hearth": ['lounge'],
                "hearth-loft": ['lounge'],
                "breeze": ['side-table', 'table', 'coffee-table'],
                "flint": ['table'],
            }
        }
        lighting_cats = ['lighting', 'pendant', 'chandelier', 'wall-sconce', 'desk-lamp', 'floor-lamp']
        furniture_cats = ['furniture', 'lounge', 'table', 'coffee-table', 'stool', 'accessories']
    }

    let lastFilterValue = '';
    $('.js-filters').on('click', 'input', function (event) {
        var id = $(this).attr('id');
        var value = $(this).val();

        if (value.length > 0 && value != lastFilterValue) {
            lastFilterValue = value;
            if ($(this).parents('.accordion__btn').length) {
                $('.js-filters input').removeAttr("checked");
                filters = {};
            }

            if (value.toLowerCase().includes('all') && value.toLowerCase() !== 'all' && !value.toLowerCase().includes("small") && !value.toLowerCase().includes("wall")) {
                const newValue = value.replaceAll('All', '');
                const $collectionInput = $('.js-filters.accordion__head').find('input[value="' + newValue + '"]');

                if (!$collectionInput.is(":checked")) {
                    $collectionInput.trigger('click');
                }

                event.preventDefault();
                return;
            } else {
                if ($(this).parents('.accordion__head').length == 0) {
                    $('.js-filters input').each(function () {
                        if ($(this).attr('value').includes('All')) {
                            $(this).removeAttr("checked");
                        }
                    })

                    $('.js-filters.accordion__head input').removeAttr("checked");
                } else {
                    $('.js-filters .accordion__options input').each(function () {
                        $(this).removeAttr("checked");
                    })
                }
            }

            var $button = $(event.currentTarget);
            var filterGroup = $(this).attr('name');

            location.hash = 'filter=' + '.' + encodeURIComponent(value);


            var collections = Object.keys(collections_obj.lighting).concat(Object.keys(collections_obj.furniture))
            var range = $(this).parents().closest('.accordion__options').data('range')

            if (!$button.val()) {
                $grid.isotope({ filter: '*' });
                return;
            }

            if ($(this).attr('data-waschecked') == 'false' && false) {

                $grid.isotope({ filter: '.collection' });
                return;
            }


            filters[filterGroup] = $button.val();

            if (jQuery.inArray(value, lighting_cats) !== -1) {
                uncheck_radio_buttons('furniture')
                uncheck_radio_buttons('collection')

                filterValue = addPrefix(value, '.')
                $grid.isotope({ filter: filterValue });
                return;

            }

            if (jQuery.inArray(value, furniture_cats) !== -1) {
                uncheck_radio_buttons('lighting')
                uncheck_radio_buttons('collection')

                filterValue = addPrefix(value, '.')
                $grid.isotope({ filter: filterValue });
                return;
            }
            if (jQuery.inArray(value, collections) !== -1) {
                uncheck_radio_buttons('lighting')
                uncheck_radio_buttons('furniture')


                filterValue = addPrefix(value, '.')
                $grid.isotope({ filter: filterValue });

                return;

            }

            data = Object.values(filters)
            var count = countProperties(data)

            if (data.includes('lighting') && count > 1 || data.includes('furniture') && count > 1 || data.includes('collection') && count > 1) {
                data = removeItemOnce(data, 'lighting');
                data = removeItemOnce(data, 'furniture');
                data = removeItemOnce(data, 'collection');

            }

            if (filters.options == "lighting" && filterGroup == "all") {
                $grid.isotope({ filter: '.lighting' });

                return;
            }
            if (filters.options == "furniture" && filters.options == "all") {
                $grid.isotope({ filter: '.furniture' });

                return;
            }


            if (data.some(item => collections.includes(item))) {
                data = data.map(el => '.' + el)
                filterValue = data.join('');

            } else {
                data = data.map(el => '.' + el)
                filterValue = data.join(',')
            }

            $grid.isotope({ filter: filterValue });
            location.hash = 'filter=' + encodeURIComponent(filterValue);
        } else {
            history.replaceState(null, null, ' ');
            $grid.isotope({ filter: '*' });
            lastFilterValue = '';
        }
    });

    $('.js-filters').on('click', 'input', function () {
        var $radio = $(this);
        var $label = $(this).parent().find('label');


        var $waschecked = $radio.attr('data-waschecked');

        // if this was previously checked
        if ($waschecked == "true") {
            $radio.prop('checked', false);
            $radio.attr('data-waschecked', "false");
        }
        else {
            $radio.attr('data-waschecked', "true");
        }
        // remove was checked from other radios

        $('.js-filters input[data-waschecked="true"]:not(#' + $radio.attr('id') + ')').attr('data-waschecked', 'false');
    });

    // Isotope filter by URL Hash 
    function filterHashBased() {
        //Store # parameter and add "." before hash
        var hashID = getHashFilter();
        var $grid = $('.js-grid')
        if (hashID != null) {
            $grid.isotope({ filter: hashID });
            return
        }

        initIsotope()


    }

    function getHashFilter() {
        var hash = location.hash;
        // get filter=filterName
        var matches = location.hash.match(/filter=([^&]+)/i);
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent(hashFilter);

    }

    function uncheck_radio_buttons($range) {
        var options = $('.accordion__options')
        var headBtn = '#' + $range
        options.each(function () {
            if ($(this).data('range') == $range) {

                var input = $(this).find('input')
                input.each(function () {
                    $(this).removeAttr("checked");
                })
            }

        })

        $(headBtn).removeAttr("checked");


    }

    function uncheck_radio_buttons_head() {
        var radioHead = $('.accordion__head .radio')

        radioHead.each(function () {

            var input = $(this).find('input')
            input.each(function () {
                $(this).removeAttr("checked");
            })
        })
    }

    function reset_filters() {
        $('.js-filters input').each(function () {
            // $(this).removeClass('isDisabled')
            $(this).parent().find('label').removeClass('isDisabled')
            $(this).disabled = false;


        })
    }

    $('.js-reset').on('click', function (event) {
        location.hash = "";
        $('.js-filters input').each(function () {
            // $(this).removeClass('isDisabled')
            $(this).parent().find('label').removeClass('isDisabled')
            $(this).disabled = false;
            $doc.find('.accordion__options input').prop('checked', false);
        })
    })

    function loadMore(st) {
        if ($('.section-shop').length == 0) {
            return
        }
        var filters = {};
        var productContainers = $('.section-shop .section__body')
        var productContainersOffsetBottom = productContainers.offset().top + productContainers.outerHeight();
        var singleProductHeight = productContainers.find('.grid .grid__col:last-child').outerHeight()
        var loadPoint = productContainersOffsetBottom - singleProductHeight;
        if (st > loadPoint) {
            var $this = $(this)
            var $container = $('.section-shop .section__body .grid')
            var filterGroup = $('.js-filters input:checked').attr('name');
            filters[filterGroup] = $('.js-filters input:checked').val();
            var filterValue = concatValues(filters);
            if (filterValue == '.undefined') {
                filterValue = '*';
            }
            var url = productContainers.find('.grid .grid__col:last-child').data('load-set')

            if (!url) {
                return;
            }
            $.ajax({
                method: 'GET',
                type: 'HTML',
                url: url,
                async: false,

                success: function (response) {
                    var $response = $(response);

                    $container.append($response)

                    loadPoint = 0

                    setTimeout(function () {
                        $container
                            .isotope('appended', $response)

                        $container.isotope({ filter: filterValue });
                        $('.section-shop .grid .grid__col').equalizeHeight()
                    }, 50);
                }
            });
        }
    }

    function loadMoreAlt(st) {
        if ($('.js-load-more').length == 0) {
            return
        }

        var productContainers = $('.js-load-more .section__inner')
        var productContainersOffsetBottom = productContainers.offset().top + productContainers.outerHeight();
        var singleProductHeight = productContainers.find('.grid .grid__col:last-child').outerHeight()
        var loadPoint = productContainersOffsetBottom - singleProductHeight;

        if (st > loadPoint) {
            var $this = $(this)
            var $container = $('.js-load-more .section__inner .grid')
            var url = productContainers.find('.grid .grid__col:last-child').data('load-set')

            if (!url) {
                return;
            }
            $.ajax({
                method: 'GET',
                type: 'HTML',
                url: url,
                async: false,

                success: function (response) {
                    var $response = $(response);

                    $container.append($response)

                    loadPoint = 0
                }
            });
        }
    }

    function stickyFilters(st) {
        if ($('.js-sticky').length == 0) {
            return;
        }
        var stickyFiltersOffsetTop = $('.js-sticky').parent().offset().top;
        var stickyFiltersHeight = $('.js-sticky').outerHeight()

        if (!$('.header').hasClass('hide') && (st + headerHeight) >= stickyFiltersOffsetTop) {
            $('.js-sticky').css('top', headerHeight);
            $('.js-sticky').parent().css('paddingTop', stickyFiltersHeight);
            $('.js-sticky').addClass('sticky')
        }

        if (!$('.header').hasClass('hide') && (st + headerHeight) <= stickyFiltersOffsetTop) {
            $('.js-sticky').removeClass('sticky')
            $('.js-sticky').parent().css('paddingTop', 0);
        }
    }

    $.fn.equalizeHeight = function () {
        var hght = 0;
        var $this = this;

        $this.outerHeight('auto');

        $this.each(function () {
            var itemHght = $(this).outerHeight();

            if (itemHght > hght) {
                hght = itemHght;
            }
        });

        $this.outerHeight(hght);
    }

    function stickySidebar(st) {
        var winWidth = $(window).width();
        if (winWidth >= 767) {

            if ($('.section-review').length == 0) {
                return;
            }
            var reviewSectionTop = $('.section-review').offset().top;
            var reviewSectionBottom = $('.section-review').offset().top + $('.section-review').outerHeight();
            var winBottom = st + $win.innerHeight()

            if (winBottom >= reviewSectionBottom) {

                $('.section-review.fixed .section__image').css('top', st - reviewSectionTop);
                $('.section-review').removeClass('fixed')
                return;
            }

            if (st >= reviewSectionTop) {
                $('.section-review').addClass('fixed')
                $('.section-review .section__image').css('top', 0);
            }

            if (st <= reviewSectionTop) {
                $('.section-review').removeClass('fixed')
                $('.section-review .section__image').css('top', 0);
            }
        }
    }

    function customCursor() {

        var body = $('body');
        var cursor = $("<div></div>").addClass('cursor')

        if (body.hasClass('woocommerce-shop')) {
            // return
        }

        $doc.find('.wrapper').eq(0).append(cursor)

        const customCursor = $('.cursor');
        const moveCursor = (e) => {
            const mouseY = e.clientY;
            const mouseX = e.clientX;

            $(customCursor).css({
                transform: `translate3d(${mouseX}px, ${mouseY}px, 0)`,
                opacity: 1
            });
        }

        $win.on('mousemove mousedown', function (e) {
            var $target = e.target
            moveCursor(e)
            if ($(e.target).hasClass('flickity-button') && $(e.target).hasClass('next')) {
                $('html').addClass('is-arrow');
                $('.cursor').removeClass('arrow--link left').addClass('arrow')
                return;
            }
            if ($(e.target).hasClass('flickity-button') && $(e.target).hasClass('previous')) {
                $('html').addClass('is-arrow');
                $('.cursor').removeClass('arrow--link').addClass('arrow left')
                return;
            }

            if ((e.target.tagName.toLowerCase() === 'a'
                || e.target.tagName.toLowerCase() === 'button'
                || e.target.tagName.toLowerCase() === 'input'
                || e.target.tagName.toLowerCase() === 'textarea'
                || e.target.tagName.toLowerCase() === 'select'
                || e.target.tagName.toLowerCase() === 'i') && e.target.type != 'range'
            ) {
                $('html').removeClass('is-arrow');
                $('.cursor').addClass('cursor--link').removeClass('arrow left');
                return;
            }

            if (e.target.tagName.toLowerCase() !== 'a'
                && e.target.tagName.toLowerCase() !== 'button'
                && e.target.tagName.toLowerCase() !== 'input'
                && e.target.tagName.toLowerCase() !== 'textarea'
                && e.target.tagName.toLowerCase() !== 'select'
                && e.target.tagName.toLowerCase() !== 'i' || e.target.type == 'range'
            ) {
                $('html').removeClass('is-arrow');
                $('.cursor').removeClass('cursor--link arrow left')
                return;
            }
        })

        $win.on('mouseout', function (e) {
            $(customCursor).css({ opacity: "0" })
        })
    }

    function setAutoScroll() {
        if ($('.js-autoscroll').length > 0) {
            var targetTop = $('.js-autoscroll-target').offset().top;
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: targetTop
                }, 1000);
            }, 4000);
        }
    }

    $doc.on('click', '.loader', function (e) {
        $(this).addClass('loaded');
    });

    function runLoaderAnimation() {
        setTimeout((function () {
            $(".loader").addClass("loaded"), function initAos() {
                const $container = $(".slider, .hero, .section, .section-simple, .article, .member, .widget-counter, .section-products, .intro, .section-tiles, .section-details, .section-review, .project, .section-shop, .form, .section-alt, .section-accordion"), $itemsUp = $(".slider .slider__content, .hero .hero__content, .section h2, .section .section__slider, .section .section__entry,.section .section__counter, .section .section__images, .section .section__content, .section .section__col, .section-simple img, .section-simple .section__content, .article .article__body, .article .article__image, .member img, .member .member__content, .section .section__cta, .widget-counter .counter, .intro h2, .intro img, .intro .intro__content, .section-details .section__title, .section-details .section__list, .section-review .section__inner, .project .project__image, .project .project__content, .form .form__inner, .section-alt .section__content, .section-accordion .accordion"), $itemsGroup = $(".section .section__list ul li, .section-products .product, .section-tiles .tile, .section-shop");
                $container.each((function () {
                    const $container = $(this), $containerItems = $container.find($itemsUp), $containerItems2 = $container.find($itemsGroup);
                    let delay = 0;
                    $containerItems.each((function () {
                        delay = $(this).attr("data-aos-delay") ? $(this).attr("data-aos-delay") : 0, $(this).attr({
                            "data-aos-delay": delay,
                            "data-aos": "fade-up-subtle",
                            "data-aos-easing": "ease-out"
                        }), delay += 80;
                    })), $containerItems2.each((function () {
                        delay = $(this).attr("data-aos-delay") ? $(this).attr("data-aos-delay") : 0, $(this).attr({
                            "data-aos-delay": delay,
                            "data-aos": "fade-up-subtle",
                            "data-aos-easing": "ease-out"
                        }), delay += 100;
                    })), $win.on("scroll resize", (function () {
                        $container.hasClass("aos-animate") && $containerItems.addClass("aos-animate");
                    })), setTimeout((function () {
                        $container.hasClass("aos-animate") && $containerItems.addClass("aos-animate");
                    }), 200);
                })), setTimeout((function () {
                    AOS.init({
                        duration: 600,
                        once: !0
                    });
                }), 200);
            }(), function setAutoScroll() {
                if ($(".js-autoscroll").length > 0) {
                    var targetTop = $(".js-autoscroll-target").offset().top;
                    setTimeout((function () {
                        if ($win.scrollTop() == 0) {
                            $("html, body").animate({
                                scrollTop: targetTop
                            }, 1e3);
                        }
                    }), 8e3);
                }
            }();
        }), 4800), setTimeout((function () {
            $(".wrapper").addClass("page-loaded");
        }), 2900);
    }

    $doc.on('change', '.variation-radios input', function () {
        $('.variation-radios input:checked').each(function (index, element) {
            let el = $(element);
            $('select[name="' + el.attr('name') + '"]').val(el.attr('value')).trigger('change');
            recreateRadioInputs();
        });
    });

    $doc.on('woocommerce_update_variation_values', function () {
        $('.variation-radios input').each(function (index, element) {
            let el = $(element);
            el.removeAttr('disabled');
            if ($('select[name="' + el.attr('name') + '"] option[value="' + el.attr('value') + '"]').is(':disabled')) {
                $el.prop('disabled', true);
            }
        });
    });

    // Recreate Radio Inputs based on the select inputs
    function recreateRadioInputs() {
        $('.variation-radios input, .variation-radios label').hide();
        $('.variations select').each(function () {
            let inputName = $(this).attr('name');
            $(this).find('option').each(function () {
                let inputVal = $(this).val();
                let radioInput = $('.variation-radios input[value="' + inputVal + '"]');
                $('.variation-radios label[for="' + radioInput.attr('id') + '"]').show();
                radioInput.show();
            });
        });
    }

    function runMenuGradient() {
        var i = 0;
        var prev = 0;
        interval3 = setInterval(function () {
            $('.menu .menu__background').toggleClass('alt')
        }, 4000);
    }

    $('.js-filter-menu .radio').on('click', function () {
        $(this)
            .parents('.js-filters')
            .addClass('is-current')
            .siblings('.accordion__body').slideDown();
    })

    $('.section__cta .btn').mouseenter(function () {
        $('.section__cta-bg').addClass('active');
    });

    $('.section__cta .btn').mouseleave(function () {
        $('.section__cta-bg').removeClass('active');
    });

    $('.js-filters-close').on('click', function (e) {
        e.preventDefault();

        $(this)
            .parents('.js-filters')
            .toggleClass('is-current')
            .siblings('.accordion__body').slideToggle();
    })

    /* 
    *
    *  Custom Swatch styles base on attribute 
    * 
    **/
    $('.image-variable-wrapper ').each(function () {
        let attr = $(this).data("attribute_name");
        if (attr != 'attribute_pa_configurations') {
            $(this).addClass("finis--attribute")
        }

    });

    $('.actions .coupon button').text(function () {
        $(this).html('Apply')
    })

    $(".actions .coupon button").text($(".actions .coupon button").text().replace("Apply Coupon", "Apply"));

    /* 
    *
    *  Specifier URL Param Based on Product Variation selection.
    * 
    */
    $('form.variations_form').on('show_variation', function (event, data) {
        // console.log( data.variation_id );      // The variation Id  <===  <===
        let params = data.attributes
        let specifier = $('.specifier-js')
        let prod_name = specifier.data('product')
        prod_name = prod_name.replace(/\s+/g, '-').toLowerCase()

        let query = [];
        let kMapping = {
            "configurations": "config"
        };

        $.each(params, function (key, value) {
            let k = kMapping[key.split("pa_").pop()] !== undefined ? kMapping[key.split("pa_").pop()] : key.split("pa_").pop();
            let inputs = $('input[name="' + key + '"]');
            let val;

            inputs.each(function () {
                if ($(this).parents('.radio__variations--item').eq(0).find('.swatch-overlay--active').length) {
                    val = $(this).attr('data-term-name');
                }
            })

            let valMapping = {
                "config": val
            };

            let query_str = '&p_' + k + '=' + (valMapping[k] !== undefined ? valMapping[k] : value);
            query.push(query_str);
        })

        let combine = query.join('')

        if (combine == '') {
            alert('empty');
            specifier.addClass('hidden')
        } else {
            specifier.removeClass('hidden')
            specifier.on('click', function (event) {
                event.preventDefault();
                var url = $(this).data('target') + '?p_name=' + prod_name + combine;
                location.replace(url);
            });
        }


    });


    $doc.on('click', 'a', function (e) {
        let $this = $(this);
        if ($this.attr('href') !== '#' && $this.attr('href').length > 0 && $('html').hasClass('safari')) {
            e.preventDefault();
            $('.cursor').css({ opacity: '0' });
            setTimeout(function () {
                window.location.href = $this.attr('href');
            }, 25);
        }
    })

    /*
    *   Swap Variation images Product Single Page
    */
    let hasInitialized = false;

    $(".variations_form").on("change", 'input', function () {
        let $parent = $(".variations_form");

        // Find all the attributes values;
        const dataAttributes = [];
        $parent.find('input[type="radio"]').each(function () {
            let $this = $(this);
            if (
                $this.attr('id') !== undefined &&
                $this.attr('id').includes("attribute") &&
                $this.siblings(".swatch-overlay--active").length > 0 ||
                $this.siblings(".swatch-simple--active").length > 0 ||
                ($this.attr('name') == "attribute_pa_voltage" && $this.is(":checked"))
            ) {
                dataAttributes.push(`[data-${$this.attr('name').replace("attribute_", "")}="${$this.attr('value')}"]`);
            }
        })

        $('.woocommerce-product-gallery__image').addClass("hidden").removeClass("visible");
        $(dataAttributes.join("")).eq(0).removeClass("hidden").addClass("visible");

    });

    /*$('form.variations_form').on('show_variation', function(event, data){
        console.log( data.variation_id );      // The variation Id  <===  <===
      
        let variation_id = data.variation_id
        let woo_product_gallery_items = $(".woocommerce-product-gallery__image");
       
        if(variation_id !== null){
           
            $.each( woo_product_gallery_items ,function(index , value){
                let item = $(this);
                let id = item.attr('data-variation')
                

                if (variation_id == id ){
                    item.removeClass("hidden")
                    item.addClass("visible")
                } else {
                    item.addClass("hidden")
                    item.removeClass("visible")
                    //$(item).fadeOut(200);
                }
            })
        }

        hasInitialized = true;
    }); */

    /* 
    *  Get URL Parameter Value Helper
    */
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    function form_is_prepopulated_banner() {
        var prepopulatedProduct = getUrlParameter('p_name');
        var banner = '<div class="prefilled__banner">YOUR SELECTED CONFIGURATION HAS BEEN PRE-FILLED BELOW</div>'
        if (prepopulatedProduct != '') {

            $('.main-content').append(banner)


        }
    }

    /* 
    *  Specifier Header and Input Field Attribute Generation
    */

    function initSpecifierFieldAttributes() {
        $('.product_form_heading').each(function () {
            const $this = $(this);
            const headingAttribute = $this.find("h4").html().replaceAll(" ", "-").toLowerCase();

            $this.attr('data-heading', headingAttribute);
            $this.nextUntil(".product_form_heading").attr("data-field-for", headingAttribute);

            const $productInputs = $('[data-field-for="' + headingAttribute + '"]');

            $productInputs.each(function () {
                const label = $(this).find('.gfield_label').html().toLowerCase().replaceAll(" ", "-");
                $(this).find('select').eq(0).attr('data-name', label);
            })
        })
    }

    /* 
    *  Form Product Icons - Image Styles  
    */
    function convertText(text) {
        let words = text.split("-"); // split the text by "-"
        let result = "";
        for (let i = 0; i < words.length; i++) {
            result += words[i].charAt(0).toUpperCase() + words[i].slice(1) + " "; // capitalize the first letter and add a space
        }
        return result.trim(); // remove the trailing space
    }

    function initGfieldChoiceInputListener() {
        $doc.on('change', '.gfield-choice-input[type="checkbox"]', function (e) {
            let $this = $(this)
            let isChecked = $this.is(":checked")

            if (isChecked) {
                $this.attr('checked', 'checked');
                $this.prop('checked', true);
            } else {
                $this.attr('checked', false);
                $this.prop('checked', false);
            }
        })
    }

    function initSpecifierFieldValues() {
        $('.gfield-choice-input').each((index, element) => {
            const $this = $(element);
            const $label = $this.closest('li').find('label');
            const $type = $this.closest('li').find('label div');
            if ($this.attr("checked") == "checked") {
                $label.addClass("swatch-overlay--active")
            }

            const searchParams = new URLSearchParams(location.search);
            const selectedProduct = getUrlParameter('p_name');
            const searchParamsMapping = [];
            const valueMapping = {
                "120v": "110-120V",
                "selv": "220-240V (LOW-VOLTAGE)",
            };

            searchParams.forEach((value, key) => {
                if (valueMapping[value] !== undefined) {
                    searchParamsMapping[key.replace("p_", "")] = valueMapping[value];
                } else {
                    searchParamsMapping[key.replace("p_", "")] = convertText(value);
                }
            });

            if ($this.attr("value") == selectedProduct) {
                const $productFields = $('[data-field-for="' + selectedProduct + '"]');
                $label.addClass("swatch-overlay--active")

                const $parentInput = $label.closest('.gchoice').find('input');
                $parentInput.trigger('click');
                $parentInput.attr("checked", "checked");
                $parentInput.prop("checked", true);
                $parentInput.trigger('change');

                $productFields.each((index, element) => {
                    const $inputParent = $(element);
                    const $input = $inputParent.find('select');
                    const fieldName = $input.attr('data-name');
                    let associatedValue = searchParamsMapping[fieldName];

                    if (associatedValue !== undefined) {

                        // find correct associated name (case sensitive)
                        $input.find("option").each(function () {
                            const optionValue = $(this).attr('value');

                            if (optionValue.toLowerCase() == associatedValue.toLowerCase()) {
                                associatedValue = optionValue;
                            }
                        })

                        $input
                            .val(associatedValue)
                            .prop("value", associatedValue)
                            .change()

                        $input.find("option")
                            .removeAttr("selected")
                            .prop("selected", false);

                        $input.find(`option[value="${associatedValue}"]`)
                            .attr("selected", "selected")
                            .prop("selected", true);

                        $inputParent.find('.select-selected').html(associatedValue);
                        $inputParent.find('.select-items div').removeClass("same-as-selected");

                        $inputParent.find('.select-items div').each((index, element) => {
                            if ($(element).html() == associatedValue) {
                                $(element).addClass("same-as-selected");
                            }
                        });
                    }
                });
            }
        });
    }

    /* 
    *  Product Attribute Radio Options - Image Styles  
    */
    $('.radio__variations--list input').each(function (e) {
        let label = $(this).parents().closest('li').find('label');
        let type = $(this).parents().closest('li').find('label div');;

        if ($(this).attr("checked") == "checked") {
            if (type.hasClass('swatch-overlay')) {
                label.addClass("swatch-overlay--active")
            }
            if (type.hasClass('swatch-simple')) {
                label.addClass("swatch-simple--active")
            }
        }
    })

    $('.swatch-overlay').click(function () {
        if ($(this).parents('.checkbox__choice').eq(0) && !$(this).parent().hasClass("swatch-overlay--active")) {
            if ($(this).parents('.checkbox__choice').eq(0).find('input').eq(0)) {
                if ($(this).parents('.checkbox__choice').eq(0).find('input').eq(0).is(':checked')) {
                    return;
                }
            }
        }

        if (!$(this).hasClass('swatch-overlay--checkbox')) {
            $('.swatch-overlay').each(function (e) {
                $(this).closest('label').removeClass('swatch-overlay--active')
            })

            $(this).closest('label').addClass('swatch-overlay--active')
        } else {
            if ($(this).parent().hasClass('swatch-overlay--active')) {
                $(this).closest('label').removeClass('swatch-overlay--active')
            } else {
                $(this).closest('label').addClass('swatch-overlay--active')
            }
        }
    })

    $('.swatch-simple').click(function () {
        $(this).parents('.swatches').eq(0).find('.swatch-simple').each(function (e) {
            $(this).closest('label').removeClass('swatch-simple--active')
        })
        $(this).closest('label').addClass('swatch-simple--active')
    })

    $('.article__content a').each(function () {
        if (!$(this).hasClass('link')) {
            $(this).addClass('link');
        }
    })

    $doc.on('gform_confirmation_loaded', function (event, formId) {
        // Hide for Specifier, Product Instructions, and 3D Models forms
        if (formId == 2 || formId == 49 || formId == 48) {
            $('.section__inner').css("display", "none")
        }

        if (formId == 6) {
            $('.btn--empty').remove();
        }
    })

    /*
    *  Populate PDF on the fly with Product Data Object
    *  Populate Enquiry Form on the fly with Product Data Object
    * 
    * */
    $('form.variations_form').on('show_variation', function (event, data) {
        // console.log( data );      // The variation Id  <===  <===

        let params = data.attributes
        let specifier = $('.specifier-js')
        let prod_name = specifier.data('product')
        let lang = $('html').attr('lang');
        let isTranslationNeeded = lang !== 'en-US' && lang !== 'en' && window.translateWords;

        $(".prod_img").remove();
        $(".attr_li").remove();

        let $enquiryForm = $('.js-product-enquiry');
        let productInformation = '';

        $var_img = ' <img class="prod_img" src="' + data.image.url + '" alt="' + data.image.alt + '">';
        $('.pdf__header--image').append($var_img);
        $enquiryForm.find('.product__thumbnail img').attr('src', data.image.url);
        $enquiryForm.find('.attributes__summary').html('');

        let productTitle = $('.product-title').html();
        productInformation += `${productTitle} \n\n`;

        // Collect all strings that need translation
        let stringsToTranslate = [];
        let translationMap = {};

        if (isTranslationNeeded) {
            stringsToTranslate.push(productTitle);
            translationMap['productTitle'] = productTitle;
        }

        $.each(params, function (key, value) {
            let k = key.split("pa_").pop();
            let val = value;

            let attr = k.replace('-', ' ');
            let attrVal = val.replace('-', ' ');

            if (attr.toLowerCase().includes("config")) {
                attr = "Configuration";
            }

            if (isTranslationNeeded) {
                stringsToTranslate.push(attr);
                stringsToTranslate.push(attrVal);
                translationMap[`attr_${key}`] = attr;
                translationMap[`attrVal_${key}`] = attrVal;
            }

            $attr_li = '<li class="attr_li"><strong>' + attr + '</strong><span>' + attrVal + '</span></li>';
            $attr_li_alt = '<li>' + attr.toUpperCase() + ': <span>' + attrVal.toUpperCase() + '</span></li>';

            $('.pdf__product--specs').append($attr_li);
            $enquiryForm.find('.attributes__summary').append($attr_li_alt);
            productInformation += `${attr.toUpperCase()}: ${attrVal.toUpperCase()} \n`;
        });

        let certification = $('.certification').find('p');
        if (certification.length) {
            if (isTranslationNeeded) {
                stringsToTranslate.push("Certification");
                translationMap['certification'] = "Certification";
            }

            $('.pdf__product--specs').append('<li class="attr_li"><strong> Certification</strong><span>');
            certification.each(function () {
                $('.pdf__product--specs').append($(this));
            });
            $('.pdf__product--specs').append('<span></li>');
        }

        let customHeight = $('#rangevalue').text();
        if (customHeight.length) {
            if (isTranslationNeeded) {
                stringsToTranslate.push("Drop Height");
                translationMap['dropHeight'] = "Drop Height";
            }

            let dropHeight = '<li class="attr_li"><strong> Drop Height</strong><span>' + customHeight + 'mm</span></li>';
            let dropHeight_alt = '<li>Drop Height: <span>' + customHeight.toUpperCase() + 'mm</span></li>';
            $('.pdf__product--specs').append(dropHeight);
            $enquiryForm.find('.attributes__summary').append(dropHeight_alt);
        }

        if (isTranslationNeeded) {
            stringsToTranslate.push("SKU");
            translationMap['sku'] = "SKU";
        }

        let sku = '<li class="attr_li"><strong> SKU</strong><span>' + data.sku + '</span></li>';
        let sku_alt = '<li>SKU: <span>' + data.sku.toUpperCase() + '</span></li>';
        $enquiryForm.find('.item__sku').html(data.sku.toUpperCase());

        $('.pdf__product--specs').append(sku);
        $enquiryForm.find('.attributes__summary').append(sku_alt);
        productInformation += `SKU: ${data.sku.toUpperCase()} \n`;

        let qty = $('.qty').val();
        if (qty) {
            if (isTranslationNeeded) {
                stringsToTranslate.push("QTY");
                translationMap['qty'] = "QTY";
            }

            $enquiryForm.find('.attributes__summary').append('<li>QTY: <span class="product--qty">' + $('.qty').val() + '</span></li>');
        }

        $doc.find('.js-enquire-product-info textarea').val(productInformation);

        // Perform translations if needed
        if (isTranslationNeeded && stringsToTranslate.length > 0) {
            window.translateWords(stringsToTranslate, lang)
                .then(translations => {
                    if (translations && translations.translation && translations.translation.to_words) {
                        let translatedWords = translations.translation.to_words;
                        let index = 0;

                        // Update product title
                        if (translationMap['productTitle']) {
                            let translatedTitle = translatedWords[index++];
                            productInformation = `${translatedTitle} \n\n`;
                        }

                        // Update attributes
                        $('.pdf__product--specs .attr_li').each(function () {
                            let $item = $(this);
                            let attrName = $item.find('strong').text().trim();

                            // Find the corresponding translation
                            for (let key in translationMap) {
                                if (translationMap[key] === attrName) {
                                    let translatedAttr = translatedWords[stringsToTranslate.indexOf(attrName)];
                                    $item.find('strong').text(translatedAttr);
                                    break;
                                }
                            }

                            // For attribute values, we need to handle them separately
                            if (!attrName.includes("SKU") && !attrName.includes("Drop Height") && !attrName.includes("Certification")) {
                                let attrValue = $item.find('span').text().trim();
                                for (let key in translationMap) {
                                    if (translationMap[key] === attrValue) {
                                        let translatedValue = translatedWords[stringsToTranslate.indexOf(attrValue)];
                                        $item.find('span').text(translatedValue);
                                        break;
                                    }
                                }
                            }
                        });

                        // Update enquiry form
                        $enquiryForm.find('.attributes__summary li').each(function () {
                            let $item = $(this);
                            let text = $item.text();
                            let parts = text.split(':');

                            if (parts.length > 0) {
                                let attrName = parts[0].trim();

                                for (let key in translationMap) {
                                    if (translationMap[key].toUpperCase() === attrName) {
                                        let translatedAttr = translatedWords[stringsToTranslate.indexOf(translationMap[key])];
                                        $item.html(translatedAttr.toUpperCase() + ': <span>' + parts[1].trim() + '</span>');
                                        break;
                                    }
                                }
                            }
                        });
                    }
                })
                .catch(error => {
                    console.error('Translation error:', error);
                });
        }
    });

    $('.btn-pdf-js').on('click', function (e) {
        e.preventDefault();
        // downloadConfiguration()
        $("#PDFcontent").printThis({
            pageTitle: "",
            header: false,               // prefix to html
            footer: false,               // prefix to html

        });

    })

    //Custom Mini Cart
    function customMiniCartBtn() {
        let btn = $('.vi-wcaio-sidebar-cart-bt-nav-checkout')
        let subtotal = $('.vi-wcaio-sidebar-cart-footer-cart_total').html()
        let container = $('.vi-wcaio-sidebar-cart-footer-action')
        let disclaimer = 'Note: Estimated shipping will be added at the checkout on the next page. Australian taxes are included in the above price, however are removed at checkout for international orders. Free pickup from our Melbourne Studio is available.';
        if (!btn.length) {
            return
        }
        btn.html('CHECKOUT<span class="cart-btn-space">|</span>' + subtotal.replace('Subtotal:', ' '))
        // container.append( '<p class="cart-pd--disclaimer">'+ disclaimer +'</p>' );

    }

    //Fake Slector Voltage Radio Buttons
    function updateVoltageValue(value) {
        let placeholder = $(this).data('placeholder')
        if (value) {
            placeholder = value
        }

        $('.voltage-selection-js').html(placeholder)
    }

    $('.voltage-js').on('click', function (e) {
        // e.preventDefault();
        let container = $(this).parent('.voltage-attribute')
        let label = $(this).find('.voltage-selection-js')

        container.toggleClass('voltage-select--active').find('.voltage-options').slideToggle();

        label.html(label.data('placeholder'));

        return false;
    });

    $('.voltage-option-js').on('click', function (e) {
        let select = $(this).parents('.voltage-attribute')
        let selection = select.find('.voltage-selection-js')
        let value = $(this).attr('data-name')

        select.removeClass('voltage-select--active').find('.voltage-options').slideToggle();
        // updateVoltageValue(value)
        selection.html(value)
    })

    //Custom Dropdowns Gravity Forms
    function initCustomDropDowns() {
        try {
            var x, i, j, l, ll, selElmnt, a, b, c;

            x = document.getElementsByClassName("ginput_container_select");
            l = x.length;

            for (i = 0; i < l; i++) {

                selElmnt = x[i].getElementsByTagName("select")[0];

                if (selElmnt.getAttribute("class") == "initalized") continue;

                ll = selElmnt.length;
                /*for each element, create a new DIV that will act as the selected item:*/
                a = document.createElement("DIV");
                a.setAttribute("class", "select-selected");
                a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
                x[i].appendChild(a);

                /*for each element, create a new DIV that will contain the option list:*/
                b = document.createElement("DIV");

                selElmnt.setAttribute("class", "initalized");
                b.setAttribute("class", "select-items select-hide");

                for (j = 0; j < ll; j++) {

                    /*for each option in the original select element,
                    create a new DIV that will act as an option item:*/
                    c = document.createElement("DIV");
                    c.innerHTML = selElmnt.options[j].innerHTML;
                    c.addEventListener("click", function (e) {

                        /*when an item is clicked, update the original select box,
                        and the selected item:*/

                        var y, i, k, s, h, sl, yl;
                        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                        sl = s.length;
                        h = this.parentNode.previousSibling;

                        for (i = 0; i < sl; i++) {
                            if (s.options[i].innerHTML == this.innerHTML) {
                                s.selectedIndex = i;
                                h.innerHTML = this.innerHTML;
                                y = this.parentNode.getElementsByClassName("same-as-selected");
                                yl = y.length;
                                for (k = 0; k < yl; k++) {
                                    y[k].removeAttribute("class");
                                }
                                this.setAttribute("class", "same-as-selected");
                                break;
                            }
                        }
                        h.click();
                    });
                    b.appendChild(c);
                }
                x[i].appendChild(b);
                a.addEventListener("click", function (e) {

                    /*when the select box is clicked, close any other select boxes,
                    and open/close the current select box:*/
                    e.stopPropagation();
                    closeAllSelect(this);
                    this.nextSibling.classList.toggle("select-hide");
                    this.classList.toggle("select-arrow-active");
                });
            }

            function closeAllSelect(elmnt) {
                /*a function that will close all select boxes in the document,
                except the current select box:*/
                var x, y, i, xl, yl, arrNo = [];
                x = document.getElementsByClassName("select-items");
                y = document.getElementsByClassName("select-selected");
                xl = x.length;
                yl = y.length;
                for (i = 0; i < yl; i++) {
                    if (elmnt == y[i]) {
                        arrNo.push(i)
                    } else {
                        y[i].classList.remove("select-arrow-active");
                    }
                }
                for (i = 0; i < xl; i++) {
                    if (arrNo.indexOf(i)) {
                        x[i].classList.add("select-hide");
                    }
                }
            }

            document.addEventListener("click", closeAllSelect);
        } catch (e) { }
    }

    /*
     Video
     */
    $('.js-video').each(function () {
        var $this = $(this);

        $win.on('load resize', function () {
            var width = $this.outerWidth();
            var height = $this.outerHeight();

            var ratioWidth = height * 1.7777;
            var ratioHeight = width * 0.5625;

            if (width > height && width > ratioWidth) {
                $this.css('--video-width', `${width}px`);
                $this.css('--video-height', `${ratioHeight}px`);
                $this.css('--video-controls-bottom', `${(ratioHeight - height) / 2}px`);
            }

            if (width > height && width < ratioWidth) {
                $this.css('--video-width', `${ratioWidth}px`);
                $this.css('--video-height', `${height}px`);
                $this.css('--video-controls-bottom', `0px`);
            }

            if (width < height) {
                $this.css('--video-width', `${ratioWidth}px`);
                $this.css('--video-height', `${height}px`);
                $this.css('--video-controls-bottom', `0px`);
            }
        });
    });

    let players = [];

    function toggleVideo(targetId) {
        let $target = $(targetId);
        let player_id = $target.data('player-id');
        let player = players[player_id];

        if (player.playing) {
            player.pause();
        } else {
            player.play();
        }
    }

    $('.js-video-trigger').on('click', function (e) {
        e.preventDefault();

        let targetId = $(this).attr('href');

        toggleVideo(targetId);
    });

    $('.js-video').each(function (i) {
        let $this = $(this);
        let $player = $this.find('.video__player');
        let config = $player.data('plyr-config');

        let player = new Plyr(
            $player.get(0),
            config
        );


        players.push(player);

        $this.attr('data-player-id', i);
    });

    $doc.on('click', '.checkout-button', function (e) {
        let $this = $(this);
        $this.html('Processing...');

        setTimeout(function () {
            $this.html('Buy now');
        }, 6000)
    })

    $doc.on('click', '.btn--cart:not(.js-email)', function () {
        let $this = $(this);
        $this.html('Adding to cart...');

        setTimeout(function () {
            $this.html('Buy now');
        }, 6000)
    });

    /*
       Quantity Button - + Behaviour
    */
    function quantity_step_btn() {
        var timeoutPlus;
        $('.quantity .step-btn.plus').one().on('click', function () {
            $input = $(this).prev('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof (step) ? parseInt(step) : 1;
            $input.val(val + step).change();

            if (timeoutPlus != undefined) {
                clearTimeout(timeoutPlus)
            }
            timeoutPlus = setTimeout(function () {
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        var timeoutMinus;
        $('.quantity .step-btn.minus').one().on('click', function () {
            $input = $(this).next('input.qty');
            var val = parseInt($input.val());
            var step = $input.attr('step');
            step = 'undefined' !== typeof (step) ? parseInt(step) : 1;
            if (val > 1) {
                $input.val(val - step).change();
            }

            if (timeoutMinus != undefined) {
                clearTimeout(timeoutMinus)
            }
            timeoutMinus = setTimeout(function () {
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });

        var timeoutInput;
        jQuery('div.woocommerce').on('change', '.qty', function () {
            if (timeoutInput != undefined) {
                clearTimeout(timeoutInput)
            }
            timeoutInput = setTimeout(function () {
                $('[name="update_cart"]').trigger('click');
            }, 1000);
        });
    }

    $doc.on('change', '.qty', function () {
        $('.item__qty').html(`QTY: ${$(this).val()}`);
        $('.product--qty').html($(this).val());
        $doc.find('.js-enquire-product-qty input').val($(this).val());
    });

    $doc.on('click', '.js-product-enquire', function (e) {
        e.preventDefault();
        $('.subscribe--alt').addClass('visible');
    })

    $('.showlogin').on('click', function (e) {
        // e.preventDefault()
        $('.woocommerce-form-login').toggleClass('woocommerce-form-login--active')
    })

    function initSpecifierLabels() {
        const attributes = [
            "Base",
            "Top Finish",
            "Body Finish",
            "Glass Finish",
            "Finish",
            "Config",
            "Upholstery",
            "Position",
            "Size",
            "Legs",
            "Qty",
            "Mirror",
            "Voltage",
        ];
        $('.gfield_label').each(function (e) {
            const $this = $(this);
            const labelText = $this.html();

            for (var i = 0; i < attributes.length; i++) {
                if (labelText.includes(attributes[i])) {
                    $this.html(attributes[i]);
                    break;
                }
            }
        });
    }

    $doc.on('gform_post_render', function () {
        setTimeout(function () {
            initSpecifierLabels()
            initCustomDropDowns()
            initSpecifierFieldAttributes();
            initSpecifierFieldValues();
        }, 20)
    })

    // $win.on('click', function(e){
    //     let target = e.target
    //     console.log(target);
    // })

    function loadImageTiles($img) {
        /*$doc.find('.item__image img').each(function() {
            let $this = $(this);
            console.log("Loading");
            $this.parents('.item').eq(0).addClass('item__loaded');
        })*/

        $img.parents('.item').eq(0).addClass('item__loaded');
    }

    $('.form-alt .button').on('click', function (e) {
        let icon = $('.subscribe__body svg');
        icon.css({ display: 'none' })
    })

    function isIOS() {
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            return true;
        } else {
            return navigator.maxTouchPoints &&
                navigator.maxTouchPoints > 2 &&
                /MacIntel/.test(navigator.platform);
        }
    }

    function isIpadOS() {
        return navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform);
    }


    const initPlyr = () => {
        $('.plyr').each(function () {
            try {
                let $this = $(this);

                let videoId = $this.attr('id');
                let autoplay = $this.attr('data-autoplay') === 'true';
                let videoType = $this.data('video-type');
                let poster = $this.attr('data-poster');
                let allowFullscreen = $this.attr('data-allow-fullscreen') === 'true';

                let controls = $this.attr('data-controls') === 'true' ? ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'] : [];
                if ($this.attr('data-mute-button') === 'true') {
                    controls = ['mute'];
                }

                const videoSettings = {
                    clickToPlay: $this.attr('data-click-to-play') === 'true',
                    controls: controls,
                    loop: { active: $this.attr('data-loop') === 'true' },
                    autoplay: autoplay && videoType === "embed",
                    fullscreen: { enabled: allowFullscreen },
                    storage: { enabled: false },
                };

                const player = new Plyr('#' + videoId, videoSettings);

                // Get the classes from the initial Plyr element
                let classes = $this.attr('class');

                // Add the classes to the new Plyr element
                $(player.elements.container).addClass(classes);

                if (poster) {
                    player.poster = $this.attr('data-poster');
                }

                if (autoplay && videoType === "file") {
                    player.volume = 0;
                    player.muted = true;
                }

                const config = {
                    rootMargin: '-15% 0%',
                    threshold: 0,
                };

                const callback = (entries) => {
                    entries.map((entry) => {
                        entry.isIntersecting && autoplay && player ? player.play() : player.pause();
                    });
                };

                let observer = new IntersectionObserver(callback, config);

                player.on('ready', () => {
                    player.pause();
                    player.muted = true;
                    player.volume = 0;
                    observer.observe($this[0]);
                });
            } catch (error) {

                if (error.message !== "Plyr is not defined") {
                    console.error('Error initializing Plyr:', error);
                } else {
                    console.error('Plyr is not defined.');
                }
            }
        });
    }

    /**
     * Language Modal - Prompts Japanese browser users to switch to JP site
     */
    function initLanguageModal() {
        // Check for force show parameter
        var forceShow = window.location.search.indexOf('langswitcher') !== -1;

        // Get browser language
        var browserLang = navigator.language || navigator.languages[0] || '';
        browserLang = browserLang.toLowerCase();

        // Check if browser language is Japanese
        var isJapanese = browserLang.startsWith('ja');

        // Check if already on JP site (URL contains /ja/)
        var isOnJPSite = window.location.pathname.indexOf('/ja/') !== -1 || window.location.pathname.startsWith('/ja');

        // Check if user has already dismissed the modal
        var hasChosenLocale = localStorage.getItem('rg_locale_choice');

        // Don't show modal if not Japanese, already on JP site, or already made a choice
        // Unless forceShow is true (via ?langswitcher URL param)
        if (!forceShow && (!isJapanese || isOnJPSite || hasChosenLocale)) {
            return;
        }

        // Create modal HTML using existing subscribe modal structure
        var modalHTML = `
            <div class="language-modal subscribe subscribe--new visible" id="language-modal">
                <a href="#" class="subscribe__close js-close-language-modal">
                    <span></span>
                    <span></span>
                </a>
                <div class="subscribe__container">
                    <div class="subscribe__head">
                        <h2>You're currently on the Ross Gardam AU site.</h2>
                    </div>
                    <div class="subscribe__body">
                        <p class="language-modal__desc">
                            Would you like to visit the Japanese site to see local prices and available products?
                        </p>
                        <a href="#" class="btn btn--black js-switch-to-jp">Switch to JP Site / JPサイトに切り替える</a>
                        <a href="#" class="btn btn--outlined js-stay-on-au">Stay on AU Site</a>
                    </div>
                </div>
            </div>
            <div class="language-modal__overlay" id="language-modal-overlay"></div>
        `;

        // Append modal to body
        $('body').append(modalHTML);

        // Handle "Switch to JP Site" click
        $('.js-switch-to-jp').on('click', function (e) {
            e.preventDefault();
            localStorage.setItem('rg_locale_choice', 'ja');

            // Use WeGlot API to switch language if available
            if (typeof Weglot !== 'undefined' && Weglot.switchTo) {
                Weglot.switchTo('ja');
            } else {
                // Fallback: redirect to /ja/ version
                window.location.href = '/ja' + window.location.pathname;
            }
        });

        // Handle "Stay on AU Site" click
        $('.js-stay-on-au').on('click', function (e) {
            e.preventDefault();
            localStorage.setItem('rg_locale_choice', 'en');
            closeLanguageModal();
        });

        // Handle close button click
        $('.js-close-language-modal').on('click', function (e) {
            e.preventDefault();
            localStorage.setItem('rg_locale_choice', 'en');
            closeLanguageModal();
        });

        // Handle overlay click
        $('#language-modal-overlay').on('click', function () {
            localStorage.setItem('rg_locale_choice', 'en');
            closeLanguageModal();
        });

        function closeLanguageModal() {
            $('#language-modal').removeClass('visible');
            $('#language-modal-overlay').fadeOut(300, function () {
                $('#language-modal, #language-modal-overlay').remove();
            });
        }
    }

    $win.on('load', function () {
        // Initialize language modal for Japanese users
        initLanguageModal();

        let timeout_class = $('.subscribe').data('action');
        setTimeout(function () {
            $('.subscribe:not(.subscribe--alt):not(.language-modal)').addClass(timeout_class);
        }, 18500);

        $('body').addClass("initialized");
        initPlyr();
        initSliders()
        clickHandlers()
        initCounter()
        initShortCounter()
        tonalCircles()
        tonalCircles2()
        tonalCircles3()
        tonalCircles4()
        customMiniCartBtn()
        filterHashBased()
        runAccordion()
        runMobileAccordion()
        customCursor()
        stickySidebar(st)
        runLoaderAnimation()
        runMenuGradient()
        filter_by_colour_url()
        initCustomDropDowns()
        initGfieldChoiceInputListener();
        form_is_prepopulated_banner()
        updateVoltageValue()
        initAos()
        initIsotope()
        initSpecifierLabels();
        quantity_step_btn();


        // $('.loader').addClass('page-done')

        if (isIOS() || isIpadOS()) {
            $('html').addClass('ios');
        }

        interval = setInterval(function () {
            tonalCircles()
        }, 4000);
        interval2 = setInterval(function () {
            tonalCircles2()
        }, 5100);
        interval3 = setInterval(function () {
            tonalCircles3()
        }, 6000);
        interval4 = setInterval(function () {
            tonalCircles4()
        }, 3550);

        tonalCirclesEvents()

        setTimeout(function () {
            $('.woocommerce-error ').fadeOut('slow');
        }, 5000);
        setTimeout(function () {
            $('.prefilled__banner ').fadeOut('slow');
        }, 5000);
        setTimeout(function () {
            $('.woocommerce-message ').fadeOut('slow');
        }, 5000);

    }).on('scroll load', function () {
        st = $win.scrollTop()
        scrollHandlers(st, lastScrollTop)
        lastScrollTop = st
    }).on('load resize', function () {
        let vh = $win.innerHeight() * 0.01;
        document.documentElement.style.setProperty('--vh', vh + "px");
        setTimeout(function () {
            $('.item .item__image').equalizeHeight()
            $('.section-shop .grid .grid__col').equalizeHeight()
        }, 100);
        // push_left()
    }).on('scroll', function () {

        st = $win.scrollTop()
        stickyFilters(st)
        lastScrollTop = st;
        stickySidebar(st)
        setTimeout(function () {
            loadMore(st)
            loadMoreAlt(st)
        }, 2000);
    }).on('load scroll resize', function () {
        headerHeight = $('.header').outerHeight()
    }).on('change haschange', function () {

        setTimeout(function () {
            $('.woocommerce-message ').fadeOut('slow');
        }, 5000);
        initIsotope()
    })

    /**
     * Way around Links not opening in  
     */
    $('.section-details').on('click', 'a', function (e) {
        e.preventDefault();
        var url = $(this).data('src');
        var target = $(this).attr('target');
        if (target == '_blank') {
            window.open(url, '_blank');
        } else {
            window.open(url);
        }

    });

    const translateWords = (words, targetLang) => {
        return new Promise((resolve, reject) => {
            if (!Array.isArray(words) || !targetLang) {
                reject(new Error('Invalid parameters: words must be an array and targetLang is required'));
                return;
            }

            var apiURL = 'https://rossgardam.com.au/api/translate/';

            // Switch URL to '/api/translate/' if on rossg.local

            if (window.location.hostname === 'rossg.local') {
                apiURL = '/api/translate/';
            }

            fetch(apiURL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    words: words,
                    target_lang: targetLang
                })
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Translation request failed');
                    }
                    return response.json();
                })
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    };

    window.translateWords = translateWords;
})(jQuery, window, document);


